import { List } from "./services/List";

const TagQuery = {
  records: [`tags?offset=$from&name=ilike.%$search%&limit=10&order=id.asc`, true],
  aggregation: [`tags?select=count()&name=ilike.%$search%`, false],
}

export default () => {
  return (
    <List
      mainKey={"name"}
      query={TagQuery}
      path="/tags"
      name="Tagi"
      plural="tagów"
      columns={(data) => (
        <>
          <div className="w-1/2 lg:w-2/12 px-4 mb-6 lg:mb-0">
            <a
              className="py-1 px-2 text-xs text-purple-500 bg-purple-50 rounded-full"
              href="#"
            >
              {data.genre}
            </a>
          </div>
        </>
      )}
    />
  );
};
